import PropTypes from "prop-types"
import { useSelector } from "react-redux"
import { Navigate } from "react-router-dom"
import { usePermissions } from "hooks/usePermissions"
import { MODULES, ACTIONS } from "utils/permissions"
import { routes } from "./routes"

/**
 * DashboardPermissionGuard - Protects the AI Dashboard route
 *
 * The dashboard requires the accounting module's full_access permission.
 * Full-access profiles (owner/admin) are always allowed; everyone else is
 * redirected to /403, including direct URL access.
 */
const DashboardPermissionGuard = ({ children }) => {
  const { role } = useSelector((store) => store.user)
  const { hasPermission } = usePermissions()

  if (!role) {
    return null
  }

  if (!hasPermission(MODULES.ACCOUNTING, ACTIONS.FULL_ACCESS)) {
    return <Navigate to={routes.forbidden403()} replace />
  }

  return children
}

DashboardPermissionGuard.propTypes = {
  children: PropTypes.node
}

export default DashboardPermissionGuard
